'use strict';

exports.__esModule = true;
var CAROUSEL_LENGTH = exports.CAROUSEL_LENGTH = 4;

var PAGE_ROW_SIZE = exports.PAGE_ROW_SIZE = 2;
var HORIZONTAL_ROW_SIZE = exports.HORIZONTAL_ROW_SIZE = 4;

var PRACTICE_PROFILE_TYPE = exports.PRACTICE_PROFILE_TYPE = 'practice';
var SPECIALIST_PROFILE_TYPE = exports.SPECIALIST_PROFILE_TYPE = 'specialist';

var SPECIALIST_REVIEWS_TAB = exports.SPECIALIST_REVIEWS_TAB = 'Reviews';
var PRACTICE_TAB = exports.PRACTICE_TAB = 'About Our Practice';
var SPECIALISTS_REVIEWS_TAB = exports.SPECIALISTS_REVIEWS_TAB = 'About Our Doctors';
var SPECIALIST_RECOMMENDATIONS_TAB = exports.SPECIALIST_RECOMMENDATIONS_TAB = 'Recommendations';
var SPECIALISTS_RECOMMENDATIONS_TAB = exports.SPECIALISTS_RECOMMENDATIONS_TAB = 'Our Recommendations';